import { apiClient } from './api';

export const appConfigService = {
  getAppConfig: () => apiClient.get('/config/app'),
  getBillingLocale: () => apiClient.get('/config/billing-locale'),
  getBillingLocaleOptions: () => apiClient.get('/config/billing-locale/options'),
  updateBillingLocale: (locale) => apiClient.patch('/config/billing-locale', { locale }),
};

export default appConfigService;
